import React, { Fragment, lazy, Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Switch } from "react-router-dom";
import wifiCrossImg from '../styles/img/wifi-cross.svg';
import Loader from "./components/Loader";
import NoNetwork from "./pages/NoNetwork";
import { getSessionKey, isSocietyDomain, isTaxDomain, setApplicationInfo } from "./services/Session";
import { notUndefinedAndNull, undefinedOrNull } from "./utils/Validation";
import PublicRoute from "./components/PublicRoute";
import Index from "./pages/Index";
import './utils/i18n';

import ReactGA from "react-ga4";


let App = lazy(() => import("./pages/App.js"));

export default class Main extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isNetworkOnline: true
        }
    }

    componentDidMount() {
        this.monitorStorage();
        this.registerNetworkMonitor();
        this.registerDomain()
        sessionStorage.removeItem("appInfoInstituteId");
        ReactGA.initialize(process.env.REACT_APP_ANALYTIC_KEY, { debug: true });




    }

    /**
       * Monitor any changes in the session, and reloads the page if there are any.
       *
       * @memberof App
       */
    async monitorStorage() {
        window.addEventListener('storage', (e) => {
            let key = e.key;
            let prevSession = e.oldValue;
            let newSession = e.newValue;

            // If the user has logged out in any of the opned tab, log out from all other tabs
            if (key === getSessionKey()) {
                if (notUndefinedAndNull(prevSession) && undefinedOrNull(newSession)) {
                    window.location.reload();
                }
            }
        })
    }

    registerNetworkMonitor() {

        if (window.addEventListener) {
            window.addEventListener('offline', () => {
                this.setState((state, props) => ({
                    isNetworkOnline: false
                }));
            });

            window.addEventListener('online', () => {
                this.setState((state, props) => ({
                    isNetworkOnline: true
                }));
            })
        }
    }


    registerDomain(){
        let app="education"
        if(isSocietyDomain()){
            app="society"
        }
        if(isTaxDomain()){
            app="tax"
        }
        setApplicationInfo(app)
    }

    renderRoutes() {

        if (!this.state.isNetworkOnline) {
            return null;
        }

        return (
            <Provider store={this.props.store}>
                <BrowserRouter>
                   <Index>
                        <Suspense fallback={<Loader show={true} />}>
                            <Switch>
                                {/* Redirect the user to the /auth URL if lands on the base URL */}
                                <Redirect exact from="/" to="/app" />
                                <PublicRoute path={`/app`} component={App} />
                            </Switch>
                        </Suspense>
                    </Index>
                </BrowserRouter>
            </Provider>
        );
    }

    renderNoNetwork() {
        if (this.state.isNetworkOnline) {
            return null;
        }
        return <NoNetwork img={wifiCrossImg} />
    }

    render() {
        return (
            <Fragment>
                {this.renderNoNetwork()}
                {this.renderRoutes()}
            </Fragment>
        );
    }
}
